import { useState } from 'react';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { Snippet } from '#components/patterns/code/snippet/Snippet.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import { DOWNLOADS_URL } from './downloads.ts';

/** Explains how people become users, for a page that already has some; the empty state explains it on its own. */
export function InviteUsersButton() {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <Button size="small" onClick={() => setIsOpen(true)}>
        Invite users
      </Button>
      <Modal isOpen={isOpen} onClose={close} shouldCloseOnOverlayClick={true}>
        <ModalHeader>Invite users</ModalHeader>
        <ModalBody>
          <p className="p">
            Share the DNClient Desktop download link with your team. Each person is added when they sign in to DNClient
            Desktop through your identity provider to enroll a device.
          </p>
          <Snippet>{DOWNLOADS_URL}</Snippet>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={close}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
